document.addEventListener('DOMContentLoaded', function() {
    var productVariantId = '50825726525759'; // Target product variant ID

    // Check if the product was removed previously
    if (localStorage.getItem('productRemoved') === productVariantId) {
        console.log('Product was removed from cart previously. Not adding it again.');
        return;
    }

    // Check cart contents
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            var productInCart = cart.items.find(item => item.variant_id == productVariantId);

            if (!productInCart) {
                // Product not in cart, add with quantity 1
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: productVariantId,
                        quantity: 1
                    })
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Product silently added to cart:', data);
                })
                .catch(error => {
                    console.error('Error adding product to cart:', error);
                });
            } else if (productInCart.quantity > 1) {
                // Product is in cart but quantity is more than 1 — update it to 1
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: productInCart.key, // Use the line item key
                        quantity: 1
                    })
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Product quantity adjusted to 1:', data);
                })
                .catch(error => {
                    console.error('Error updating product quantity:', error);
                });
            } else {
                console.log('Product is already in the cart with correct quantity.');
            }
        })
        .catch(error => {
            console.error('Error checking cart contents:', error);
        });
});

// Listen for the removal of an item from the cart
document.addEventListener('cart:remove', function(event) {
    var removedProductVariantId = event.detail.variant_id;

    if (removedProductVariantId === '45163259593023') {
        localStorage.setItem('productRemoved', removedProductVariantId);
        console.log('Product removed from cart, flag set in localStorage');
    }
});
